















import TableFilters from "../../core/Table/TableFilters.vue";
import TableSort from "../../core/Table/TableSort.vue";
import { TableColumn } from "../../models/UI/TableColumn";
import { EmployeApi } from "../../api/EmployeApi";
import { Option } from "../../models/Option";

export default {
    name: "BulletinDeSalaireListFilters",
    components: { TableSort, TableFilters },
    props: {
        defaultFilters: URLSearchParams,
    },
    data() {
        return {
            filters: {},
            EmployeApi: new EmployeApi(),
            columns: [
                {
                    id: "month",
                    name: "Mois",
                    type: TableColumn.ColumnType.month_year,
                    sort_field: "month",
                },
                {
                    id: "employeIds",
                    name: "Employé",
                    type: TableColumn.ColumnType.tags,
                    options: [],
                    sort_field: "employes.nom",
                },
                {
                    id: "totalBrut",
                    name: "Total brut",
                    sort_field: "total_brut",
                },
                {
                    id: "totalNet",
                    name: "Total net",
                    sort_field: "total_net",
                },
                {
                    id: "totalEmployeur",
                    name: "Total employeur",
                    sort_field: "total_employeur",
                },
                {
                    id: "created_at",
                    name: "Date d'ajout",
                    sort_field: "created_at",
                    default_sort: true,
                    default_value: TableColumn.SortOrder.desc,
                },
            ],
        };
    },
    created() {
        let self = this;
        self.EmployeApi.getAllAsOptions({
            useCache: true,
        }).then(function (response) {
            let col = _.find(self.columns, { id: "employeIds" });
            col.options = Option.toTags(response);
        });
    },
    methods: {
        updateFilters(filters): void {
            this.filters = filters;
            this.$emit("update-filters", this.getFilters());
            this.$emit("input", this.getFilters());
        },
        updateSort(sort): void {
            this.$emit("update-sort", sort);
        },
        getFilters() {
            // Filtre employé vide
            if (
                this.filters.employeIds &&
                _.includes(this.filters.employeIds, "-1")
            ) {
                this.filters.emptyEmploye = true;
            }
            return _.merge({}, this.filters);
        },
    },
};
